module.exports = __webpack_public_path__ + "img/p-buy-al.cd2bb944.png";